import React from 'react';
import { Form, Input, Button, Row, Col, Typography, Space } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { generateKPI, getKPIById, updateKpi } from './kpiThunk';
import KPIDisplay from '../../app/components/kpiDisplay';
import { useSearchParams } from 'react-router-dom';

const { Title } = Typography;



const KpiForm: React.FC<any> = ({ }) => {
    const [form] = Form.useForm();
    const [isDirty, setIsDirty] = React.useState(false);
    const dispatch = useAppDispatch();

    const generatedKpiResponse = useAppSelector((state) => state.kpi.generatedKpiResponse);
    const kpiData = useAppSelector((state) => state.kpi.kpi);

    let [query, setQueryParams] = useSearchParams();

    React.useEffect(() => {
        if (kpiData) {
            form.setFieldsValue({
                title: kpiData.title || '',
                description: kpiData.description || '',
            });
            setIsDirty(false);
        }
    }, [kpiData]);

    React.useEffect(() => {
        const kpiId = query.get('kpiId');
        if (kpiId ) {
            dispatch(getKPIById(kpiId));
        }
    }, [query]);

    const handleSave = () => {
        form
            .validateFields()
            .then(values => {
                const data = {
                    _id: kpiData._id,
                    title: values.title,
                    description: values.description,
                    collectionName: generatedKpiResponse?.collectionName || kpiData.collectionName,
                    pipeline: generatedKpiResponse?.pipeline || kpiData.pipeline,
                    keyMeta: generatedKpiResponse?.keyMeta || kpiData.keyMeta,
                    respresentationType: generatedKpiResponse?.respresentationType || kpiData.respresentationType,
                }
                dispatch(updateKpi(data))
                    .then(() => {
                        dispatch(getKPIById(kpiData._id));
                    })
                    .finally(() => {
                        setIsDirty(false);
                    });
            })
            .catch(info => {
                // handle validation errors
                console.log('Validate Failed:', info);
            });
    };

    const handleReset = () => {
        form.setFieldsValue({
            title: kpiData.title || '',
            description: kpiData.description || '',
        });
        setIsDirty(false);
    };

    const handleValuesChange = () => {
        setIsDirty(true);
    };

    const generate = () => {
        const description = form.getFieldValue('description');
        dispatch(generateKPI({ description }))
    }

    return (
        <div style={{ maxWidth: 600, margin: '0 auto', padding: 24 }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
                <Col>
                    <Title level={3} style={{ margin: 0 }}>KPI Form</Title>
                </Col>
                <Col>
                    <Space>
                        <Button onClick={handleReset} disabled={!isDirty}>Reset</Button>
                        <Button type="primary" onClick={handleSave} disabled={!isDirty}>
                            Save
                        </Button>
                    </Space>
                </Col>
            </Row>
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValuesChange}
            >
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true, message: 'Please input the title!' }]}
                >
                    <Input placeholder="Enter title" />
                </Form.Item>
                <Space.Compact direction="vertical" style={{ width: '100%', marginBottom: 32 }}>
                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: true, message: 'Please input the description!' }]}
                        style={{ marginBottom: 0 }}
                    >
                        <Input.TextArea placeholder="Enter description" autoSize={{ minRows: 4, maxRows: 10 }} name='description' />
                    </Form.Item>
                    <Button type="primary" disabled={!isDirty} onClick={generate}>Generate <SendOutlined /></Button>
                </Space.Compact>
            </Form>

            <KPIDisplay title={kpiData.title} kpiResponse={Object.keys(generatedKpiResponse).length? generatedKpiResponse: kpiData} />
        </div>
    );
};

export default KpiForm;